export const CATALOG_ID = 'catalogId'
export const LANG_ID = 'langId'
export const STORE_ID = 'storeId'
export const PAGE_NAME = 'pageName'
export const ORDER_ID = 'orderId'
export const FROM_PAGE_NAME = 'fromPageName'
export const REF = 'ref'

export const MEMBER_ID = 'memberId'
export const RESELLER = 'reseller'
export const HASHTAG = '#'
